import { Theme } from "@mui/material/styles";

const contentBoxStyle = {
  paper: {
    padding: { xs: "1rem", md: "1.5rem" },
    marginBottom: "1rem",
  },
  heading: {
    marginBottom: "1rem",
  },
  headingWithIcon: {
    display: "flex",
    alignItems: "center",
  },
  iconContainer: {
    width: "70px",
    height: "70px",
    padding: "14px",
  },
  icon: {
    minWidth: "40px",
    minHeight: "40px",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  divider: (theme: Theme) => ({
    color: theme.palette.divider,
    marginTop: "0.5rem",
    marginBottom: "1rem",
  }),
};

export default contentBoxStyle;
